import { StaffList } from '../features/staff';

export default function StaffPage() {
  return (
    <div className="mx-auto max-w-6xl p-6">
      <StaffList />
    </div>
  );
}
